import { FC } from "react";
import { useMediaQuery } from "@/hook/use-media-query";
import { ProductCardUI } from "@/components/product-card/product-card-ui";
import { ProductDetailsResponse } from "@/types/product";

const RelatedItemList: FC<{
  lists: ProductDetailsResponse[];
}> = ({ lists }) => {
  const lg = useMediaQuery("(min-width: 1024px)");
  const xl = useMediaQuery("(min-width: 1280px)");

  const displayLists = lists.slice(
    0,
    (xl && 5) || (lg && 4) || 3,
  );

  return (
    <div className="hidden sm:grid grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 items-stretch">
      {displayLists.map((list) => (
        <div
          key={list.id}
          className="w-full h-full min-h-0 flex [&>div]:w-full [&>div]:h-full [&>div]:min-w-0 [&>div]:max-w-full"
        >
          <ProductCardUI product={list} pageType="relatedProduct" />
        </div>
      ))}
    </div>
  );
};

export default RelatedItemList;
